import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="piggy-footer py-5 mt-auto">
      <div className="container">
        <div className="row align-items-start g-4">
          {/* Brand column */}
          <div className="col-md-4">
            <p className="fw-bold mb-1" style={{ letterSpacing: '0.12em', fontSize: '1rem' }}>
              PORK CO.
            </p>
            <p className="small mb-0" style={{ color: '#888' }}>
              Premium pig-inspired goods.<br />Original designs.
            </p>
          </div>

          {/* Links column */}
          <div className="col-md-4">
            <p className="fw-semibold small mb-2 text-uppercase" style={{ letterSpacing: '0.08em' }}>
              Shop
            </p>
            <ul className="list-unstyled small mb-0">
              <li><Link to="/products" className="text-decoration-none" style={{ color: '#888' }}>All Products</Link></li>
              <li><Link to="/cart" className="text-decoration-none" style={{ color: '#888' }}>Cart</Link></li>
            </ul>
          </div>

          {/* Account column */}
          <div className="col-md-4">
            <p className="fw-semibold small mb-2 text-uppercase" style={{ letterSpacing: '0.08em' }}>
              Account
            </p>
            <ul className="list-unstyled small mb-0">
              <li><Link to="/login" className="text-decoration-none" style={{ color: '#888' }}>Login</Link></li>
              <li><Link to="/signup" className="text-decoration-none" style={{ color: '#888' }}>Sign Up</Link></li>
            </ul>
          </div>
        </div>

        <hr style={{ borderColor: '#e0e0e0', marginTop: '2rem' }} />
        <p className="mb-0 small text-center" style={{ color: '#aaa' }}>
          &copy; {new Date().getFullYear()} Pork Co. All rights reserved.
        </p>
      </div>
    </footer>
  );
}

export default Footer;
